import * as React from "react";
import {useEffect, useState} from "react";
import {Alert, Button} from "react-bootstrap";
import ImageComponent from "./ImageComponent";
import {populateImageUrl} from "../service/ImageService";
import {downloadImagesAsZip} from "../lib/downloadImagesZip";
import {
    BulkDeleteConfirmModal,
    BulkDeleteToolbar,
    useBulkImageDelete,
} from "./BulkImageDelete";


export default function JobImageGallary(props) {
    const {job, isReadOnly, images, setImages} = props

    const [isLoading, setIsLoading] = useState(false)
    const [isDownloadingAll, setIsDownloadingAll] = useState(false)
    const [downloadError, setDownloadError] = useState("")

    const bulk = useBulkImageDelete(images, setImages);

    function isUrlExpired(url) {
        if (!url) return true;
        const params = new URLSearchParams(url.split('?')[1]);
        const expireSeconds = parseInt(params.get('X-Goog-Expires'), 10);
        const startTime = params.get('X-Goog-Date');

        const year = startTime.slice(0, 4);
        const month = startTime.slice(4, 6);
        const day = startTime.slice(6, 8);
        const hour = startTime.slice(9, 11);
        const minute = startTime.slice(11, 13);
        const second = startTime.slice(13, 15);

        const isoString = `${year}-${month}-${day}T${hour}:${minute}:${second}Z`;
        const startDate = new Date(isoString);

        //Start time plus expire seconds
        startDate.setSeconds(startDate.getSeconds() + expireSeconds);
        return new Date() > startDate;
    }

    // useEffect(() => {
    //     let changedImages = []
    //     images?.forEach((image) => {
    //         if (isUrlExpired(image.downloadUrl)) {
    //             changedImages.push({
    //                 ...image,
    //                 downloadUrl: undefined,
    //                 thumbnailUrl: undefined
    //             })
    //         }
    //     })
    //     if (changedImages.length > 0) {
    //         // dispatch(updateImageInQuote({
    //         //     agentId: selectedUser.id,
    //         //     images: changedImages
    //         // }))
    //     }
    // }, [])


    useEffect(() => {
        setIsLoading(true)
        populateImageUrl(job.cos_job_id).then(async (imagesResponse) => {
            if (imagesResponse.status === 200) {
                imagesResponse.json().then((data) => {
                    setImages(data)
                })
            }
        }).finally(() => setIsLoading(false))

    }, [job])

    const imageSize = 100

    async function handleDownloadAll() {
        if (!images?.length) {
            return;
        }

        setDownloadError("");
        setIsDownloadingAll(true);

        try {
            await downloadImagesAsZip(job, images);
        } catch (error) {
            console.error("Failed to download all images", error);
            setDownloadError("Unable to download all images.");
        } finally {
            setIsDownloadingAll(false);
        }
    }

    return (
        <div>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px", gap: "8px", flexWrap: "wrap"}}>
                {!isReadOnly ? (
                    <BulkDeleteToolbar
                        totalCount={images?.length || 0}
                        selectedCount={bulk.selectedIds.size}
                        allSelected={bulk.allSelected}
                        onToggleSelectAll={bulk.toggleSelectAll}
                        onDeleteSelected={bulk.openConfirm}
                    />
                ) : <span/>}
                <Button
                    variant="outline-secondary"
                    disabled={isLoading || isDownloadingAll || !images?.length}
                    onClick={handleDownloadAll}
                >
                    {isDownloadingAll ? "Downloading..." : "Download all"}
                </Button>
            </div>
            {downloadError ? (
                <Alert variant="danger" className="mt-2 mb-0">
                    {downloadError}
                </Alert>
            ) : null}
            <div style={{display: 'flex', flexWrap: 'wrap', gap: '20px', marginTop: '10px',
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center'
            }}>
                {isLoading && <div>Loading Images... <img width={"100px"} src={"/loading.gif"}/></div>}

                {images && images.map((item) => (
                    <ImageComponent
                        key={item.id}
                        isReadOnly={isReadOnly}
                        item={item}
                        alt={item.title}
                        loading="lazy"
                        width={imageSize}
                        height={imageSize}
                        isSelected={bulk.selectedIds.has(item.id)}
                        onToggleSelect={isReadOnly ? undefined : bulk.toggleSelect}
                    />

                ))}
            </div>
            <BulkDeleteConfirmModal
                show={bulk.showConfirm}
                isDeleting={bulk.isDeleting}
                completedCount={bulk.completedCount}
                idsToDelete={bulk.idsToDelete}
                errors={bulk.errors}
                onCancel={bulk.closeConfirm}
                onConfirm={bulk.runBulkDelete}
                onClose={bulk.closeConfirm}
                onRequestCancel={bulk.requestCancel}
            />
        </div>

    )
}
